import { GameServices } from '../../services/game-services';
import { StartViewModel } from '../components/start-view-model';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BoardScalingMetrics } from '../../services/game-metrics-service';
import { CardDeckViewModel } from '../entities/card-deck-view-model';
import { NextViewModel } from '../entities/next-view-model';
import { CurrentViewModel } from '../entities/current-view-model';
import { ColumnViewModel } from '../entities/column-view-model';
import { TwentyOne } from 'game-logic';
import { LoadingColumnViewModel } from '../entities/loading-column-view-model';

export class GameBoardViewModel {
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }

  public readonly startViewModel: StartViewModel;
  public readonly cardDeckViewModel: CardDeckViewModel;
  public readonly nextViewModel: NextViewModel;
  public readonly currentViewModel: CurrentViewModel;
  public readonly loadingColumnViewModels: LoadingColumnViewModel[];
  public readonly columnViewModels: ColumnViewModel[];

  constructor(private gameServices: GameServices) {
    this.startViewModel = new StartViewModel(gameServices);
    this.cardDeckViewModel = new CardDeckViewModel(gameServices);
    this.nextViewModel = new NextViewModel(gameServices);
    this.currentViewModel = new CurrentViewModel(gameServices);

    const allColumns = [
      TwentyOne.PileId.Column1,
      TwentyOne.PileId.Column2,
      TwentyOne.PileId.Column3,
      TwentyOne.PileId.Column4,
    ];
    this.loadingColumnViewModels = allColumns.map(
      (columnId) => new LoadingColumnViewModel(gameServices, columnId),
    );
    this.columnViewModels = allColumns.map(
      (columnId) => new ColumnViewModel(gameServices, columnId),
    );
  }

  public showStartButton(showButton: boolean) {
    this.startViewModel.showStartButton(showButton);
  }

  public resetGameScene() {
    this.cardDeckViewModel.resetGameScene();
    this.nextViewModel.resetGameScene();
    this.currentViewModel.resetGameScene();
    this.loadingColumnViewModels.forEach((viewModel) => viewModel.resetGameScene());
    this.columnViewModels.forEach((viewModel) => viewModel.resetGameScene());
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): BoardScalingMetrics {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public copyTestCase(): void {
    this.gameServices.twentyOneGameRunner.copyTestCase();
  }
}
